/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Drop } from './Drop';
import {
    DropFromJSON,
    DropFromJSONTyped,
    DropToJSON,
    DropToJSONTyped,
} from './Drop';

/**
 * 
 * @export
 * @interface DropsMeOwnedResponse
 */
export interface DropsMeOwnedResponse {
    /**
     * 
     * @type {Array<Drop>}
     * @memberof DropsMeOwnedResponse
     */
    drops: Array<Drop>;
}

/**
 * Check if a given object implements the DropsMeOwnedResponse interface.
 */
export function instanceOfDropsMeOwnedResponse(value: object): value is DropsMeOwnedResponse {
    if (!('drops' in value) || value['drops'] === undefined) return false;
    return true;
}

export function DropsMeOwnedResponseFromJSON(json: any): DropsMeOwnedResponse {
    return DropsMeOwnedResponseFromJSONTyped(json, false);
}

export function DropsMeOwnedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropsMeOwnedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'drops': ((json['drops'] as Array<any>).map(DropFromJSON)),
    };
}

export function DropsMeOwnedResponseToJSON(json: any): DropsMeOwnedResponse {
    return DropsMeOwnedResponseToJSONTyped(json, false);
}

export function DropsMeOwnedResponseToJSONTyped(value?: DropsMeOwnedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'drops': ((value['drops'] as Array<any>).map(DropToJSON)),
    };
}

